import React from 'react'
import { useOutletContext } from 'react-router-dom'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import EditIcon from '@mui/icons-material/Edit'
import EditOffIcon from '@mui/icons-material/EditOff'
import { useQuery } from '~/client/hooks/cqrpc'

import Link from '~/client/components/Link'
import Timestamp from '~/client/components/Timestamp'
import ErrorMessage from '~/client/components/ErrorMessage'
import AppIcon from '~/client/components/AppIcon'
import UnshareDocumentButton from '~/client/components/UnshareDocumentButton'


export default function DocumentSharingPage() {
  const { document } = useOutletContext()
  const { result: sharings = [], error, reload} =
    useQuery('documents.getAppAccountPermissions', { id: document.id })
  return <div>
    <ErrorMessage error={error}/>
    <TableContainer sx={{maxWidth: '75vw'}}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>App</TableCell>
            <TableCell>Shared</TableCell>
            <TableCell>Permissions</TableCell>
            <TableCell>Last Read</TableCell>
            <TableCell>Last Edit</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{
          '&:last-child td, &:last-child th': {
            border: 0
          }
        }}>
        {sharings.map(sharing =>
          <TableRow key={sharing.id}>
            <TableCell sx={{p: 1}}>
              <Link to={`/accounts/${sharing.appAccount.id}`}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Stack direction="row">
                    {/*<AppAccountAvatar appAccount={sharing.appAccount}/>*/}
                    <AppIcon
                      app={sharing.appAccount.app}
                      sx={{ml: '-5px'}}
                    />
                  </Stack>
                  <div>{sharing.appAccount.app.name}</div>
                </Stack>
              </Link>
            </TableCell>
            <TableCell sx={{p: 1}}>
              <Timestamp at={sharing.createdAt} sx={{fontSize: 'smaller' }}/>
            </TableCell>
            <TableCell sx={{p: 1}}>
              {sharing.read
                ? <abbr title="can read"><VisibilityIcon/></abbr>
                : <abbr title="cannot read"><VisibilityOffIcon/></abbr>
              }
              {sharing.write
                ? <abbr title="can edit"><EditIcon/></abbr>
                : <abbr title="cannot edit"><EditOffIcon/></abbr>
              }
            </TableCell>
            <TableCell sx={{p: 1}}>
              <Timestamp at={sharing.createdAt} sx={{fontSize: 'smaller' }}/>
            </TableCell>
            <TableCell sx={{p: 1}}>
              {sharing.write
                ? <Timestamp at={sharing.document.updatedAt} sx={{fontSize: 'smaller' }}/>
                : <Box component="abbr" title="editing not permitted" sx={{textDecoration: 'none'}}>never</Box>
              }

            </TableCell>
            <TableCell sx={{p: 1, overflow: 'scroll'}}>
              <UnshareDocumentButton {...{
                appAccountId: sharing.appAccountId,
                documentId: sharing.documentId,
                onSuccess: () => reload(),
              }}/>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
      </Table>
    </TableContainer>
  </div>
}
